(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eros-catalog"] && !Shopify.designMode) return;
  try {
    
function erosFormatFilters(root) {
  root.querySelectorAll('.eg-format-filter[hidden]').forEach(control => {
    const select = control.querySelector('select');
    const cards = [...control.closest('.eg-catalog').querySelectorAll('.eg-piece')];
    const formats = [...new Set(cards.map(card => card.dataset.format).filter(Boolean))];
    if (formats.length < 2) return;
    formats.forEach(format => { const option = document.createElement('option'); option.value = format; option.textContent = format; select.append(option); });
    select.addEventListener('change', () => cards.forEach(card => { card.hidden = Boolean(select.value && card.dataset.format !== select.value); }));
    control.hidden = false;
  });
}
erosFormatFilters(document);
document.addEventListener('shopify:section:load', event => erosFormatFilters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eros-sessions-story"] && !Shopify.designMode) return;
  try {
    

class ErosSessionStory extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    const select = this.querySelector('select[name="session_package"]');
    const update = () => {
      const option = select.selectedOptions[0];
      const cents = Number(option.dataset.price);
      const whatsapp = this.querySelector('[data-whatsapp]');
      let message = whatsapp.dataset.message.replace('{package}', option.textContent.trim());
      const attribution = new URLSearchParams(window.location.search);
      if (attribution.get('utm_campaign') === 'sesiones_cdmx_rutas_oct2026' && attribution.get('utm_content') === 'esta_version_landing') {
        message += document.documentElement.lang.startsWith('en') ? ' I came to the sessions page from the Instagram ad.' : ' Llegué a la página de sesiones desde el anuncio de Instagram.';
      }
      whatsapp.href = whatsapp.dataset.base + '?text=' + encodeURIComponent(message);
      this.querySelector('[data-web-booking]').href = option.dataset.url;
      const prefix = option.dataset.prefix ? option.dataset.prefix + ' ' : '';
      const format = value => prefix + new Intl.NumberFormat(document.documentElement.lang === 'en' ? 'en-MX' : 'es-MX', { style:'currency', currency:'MXN', maximumFractionDigits:0 }).format(value / 100) + ' MXN';
      this.querySelector('[data-total]').textContent = format(cents);
      this.querySelector('[data-deposit]').textContent = format(cents / 2);
      this.querySelector('[data-balance]').textContent = format(cents / 2);
    };
    select.addEventListener('change', update);
    this.querySelectorAll('[data-select]').forEach(link => link.addEventListener('click', () => {
      select.value = link.dataset.select;
      update();
    }));
    update();
  }
}
if (!customElements.get('eros-session-story')) customElements.define('eros-session-story', ErosSessionStory);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
